export class DateRange {
	startDate: Date;
	endDate: Date;
}

export class DateRangeMillis {
	startDateMillis: number;
	endDateMillis: number;
}
